import React from 'react';
import DefaultLayout from '../layouts/DefaultLayout';
import Button from '../components/Button';
import Subsection from '../components/Subsection';
import styled from 'styled-components';
import { respondTo } from '../util/breakpoints';
import { Body, Ul } from '../util/typography';
import * as colors from '../util/colors';
import { jobCodes } from '../util/data/jobCodes';

/* 
    For documentation purposes - this page is a little bit of a one-off from the design system
*/

// SEO INFORMATION
const pageMeta = {
  title: `Sitemap | KEYTRUDA® (pembrolizumab) and LENVIMA® (lenvatinib)`,
  keywords: `keytruda and lenima, sitemap`,
  description: `Browse the KEYTRUDA® (pembrolizumab) and LENVIMA® (lenvatinib) sitemap for faster navigation of the website. View sitemap here.`,
  schemaJsonLD: [
    `{"@context":"https://schema.org/","url":"https://www.keytrudalenvimahcp.com/sitemap/","@type":"MedicalAudience","audienceType":"Health Care Professionals","geographicArea":"This site is intended for health care professionals of the United States, its territories, and Puerto Rico."}`,

    `{"@context":"https://schema.org/","url":"https://www.keytrudalenvimahcp.com/sitemap/","@type":"MedicalWebPage","name":"Site Map"}`
  ]
}

const jobCode = jobCodes[0].jobCode;

const CustomButton = styled(Button)`
  &.tertiary-dark {
      justify-content: space-between;
      align-items: center;
      width: 100%;
      color:${colors.blueDark} !important;
      
       &:hover{
                  color:${colors.focus} !important;
                   img {
                       filter: brightness(0%) saturate(100%) 
           invert(15%) sepia(85%) saturate(850%) 
           hue-rotate(190deg) brightness(96%) contrast(90%);
                   }
               }
      ${respondTo.md`
          width: 130%;
          justify-content: flex-start;
      `}
      img{
        filter: invert(26%) sepia(99%) saturate(747%) hue-rotate(176deg) brightness(96%) contrast(101%);

      }
  }
`;

const CustomContainer = styled.section`
  display: flex;
  flex-direction: column;
  padding: 10px 0px 40px 0px;
  max-width: 280px;

  a {
    margin-bottom: 12px;
  }

  ul { 
    margin-left: 17px;
  li{
    &:first-child {
      margin-bottom: 0;
      a {
        margin-bottom: 0;
      }
    }
  }
  }

  p {
    margin: 10px 0 8px 0;
  }

  ${respondTo.md`
    padding: 10px 30px 40px 0;
    max-width: 347px;
  `}
`;

const List = styled(Ul)`
  li::before {
    top: 18px;
  }
`;

const links = [
  {
    href: '/treatment-management-and-dose-modifications',
    text: 'Safety'
  },
  {
    href: '/patient-support',
    text: 'Patient Support'
  },
]

const resourcesLinks = [
  {
    href: '/professional-resources',
    text: 'HCP Resources'
  },
  {
    href: '/mechanisms-of-action/',
    text: 'Mechanisms of Action'
  }
]
const dosingLinks = [
  {
    href: '/dosing/',
    text: 'Dosing & Administration'
  },
  {
    href: '/treatment-management-and-dose-modifications/',
    text: 'Dose Modifications'
  }
]

const efficacyLinks = [
  {
    href: '/advanced-renal-cell-carcinoma/',
    text: 'Advanced Renal Cell Carcinoma'
  },
  {
    href: '/endometrial-carcinoma/',
    text: 'Advanced Endometrial Carcinoma'
  },
]
const safetyLinks = [
  {
    href: '/warnings-and-precautions/',
    text: 'Summary of Warnings & Precautions'
  },
  {
    href: '/advanced-renal-cell-carcinoma/#adverse-reaction/',
    text: 'Advanced Renal Cell Carcinoma'
  },
  {
    href: '/advanced-renal-cell-carcinoma/#adverse-reaction/',
    text: 'Advanced Endometrial Carcinoma'
  },
  {
    href: '/treatment-management-and-dose-modifications/',
    text: 'Treatment Management & Dose Modifications'
  },
]


const Index = ({location}) => {

  return (
    <DefaultLayout location={ location } name='Site Map' pageMeta={pageMeta} jobCode={jobCode}>
      <Subsection>
        <CustomContainer>
          <CustomButton type='tertiary-dark' to='/'>Home</CustomButton>
          <Body><b>Efficacy</b></Body>
          <List marker={colors.charcoal}>
            { efficacyLinks.map((link) => (
              <li key={link.href}>
                <CustomButton type='tertiary-dark' to={link.href}>{link.text}</CustomButton>
              </li>
            ))}
          </List>
          <Body><b>Safety</b></Body>
          <List marker={colors.charcoal}>
            { safetyLinks.map((link) => (
              <li key={link.href}>
                <CustomButton type='tertiary-dark' to={link.href}>{link.text}</CustomButton>
              </li>
            ))}
          </List>
            
          <Body><b>Dosing</b></Body>
          <List marker={colors.charcoal}>
            { dosingLinks.map((link) => (
              <li key={link.href}>
                <CustomButton type='tertiary-dark' to={link.href}>{link.text}</CustomButton>
              </li>
            ))}
          </List>
          <CustomButton key='/patient-support' type='tertiary-dark' to='/patient-support'>Patient Support</CustomButton>
          <Body><b>Resources</b></Body>
          <List marker={colors.charcoal}>
            { resourcesLinks.map((link) => (
              <li key={link.href}>
                <CustomButton type='tertiary-dark' to={link.href}>{link.text}</CustomButton>
              </li>
            ))}
          </List>
        </CustomContainer>
      </Subsection>
    </DefaultLayout>
  )
};

export default Index;
